import { render, staticRenderFns } from "./locationManagement.vue?vue&type=template&id=64dcd40b&"
import script from "./locationManagement.vue?vue&type=script&lang=js&"
export * from "./locationManagement.vue?vue&type=script&lang=js&"
import style0 from "./locationManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports